import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DialogWrapperWidgetComponent } from '../widgets/dialog-wrapper/dialog-wrapper.component';

import { Observable, Subject } from 'rxjs';
import { MultiLangField } from 'src/app/shared/customization/multilang-input/multi-language';
import { LANGUAGES } from 'src/app/core/config/config.constants';

@Injectable({
  providedIn: 'root'
})
export class WidgetsService {
  interactivePlotSubject$: Subject<any> = new Subject<any>();

  applyDateFilter$: Subject<any> = new Subject<any>();
  applyVehicleFilter$: Subject<any> = new Subject<any>();
  chartZoomed$: Subject<any> = new Subject<any>();
  rowClicked$: Subject<any> = new Subject<any>();
  gridResized$: Subject<any> = new Subject<any>();
  onChartConfigChanged$: Subject<any> = new Subject<any>();
  onEnableChartsSync$: Subject<boolean> = new Subject<boolean>();
  resetData$: Subject<void> = new Subject<void>();

  onUpdateWidgetOnConfigChange$: Subject<void> = new Subject<void>();
  onImageChanged$: Subject<any> = new Subject<any>();
  
  constructor(private _dialog: MatDialog) { }

  expandChartInTableView(data: any) {
    const dialogRef = this._dialog.open(DialogWrapperWidgetComponent, {
      data: data
    });
  }

  onPieClick(event: any) {
  }

  handleZoomEvent(chart: any) {
    const zoomedFilter = chart.chart.scales.x.ticks.map((tick: any) => {
      return tick.label;
    });
    console.log('Zoomed filter:', zoomedFilter);
    this.chartZoomed$.next(zoomedFilter);
  }

  /**
   * Exports data as an XLSX file using the xlsx library.
   * @param data Array of row objects
   * @param columns Array of column names (header order)
   * @param fileName Optional file name (default: 'data.xlsx')
   */
  exportDataInXlsx(data: any[], columns: string[], fileName: string = 'data') {
    // Dynamically import xlsx only when needed
    import('xlsx').then(xlsx => {
      // Prepare worksheet data: first row is header
      const wsData = [columns, ...data.map(row => columns.map(col => row[col]))];
      const ws = xlsx.utils.aoa_to_sheet(wsData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
      xlsx.writeFile(wb, fileName + '.xlsx');
    });
  }

  exportDataInCsv(data: any[], columns: string[]) {
    const header = columns.join(',');
    const rows = data.map(row => {
      return columns.map(col => row[col]).join(',');
    });
    const csvContent = [header, ...rows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportChartAsImage(img: any, fileName: string) {
    //const img = chart.toBase64Image('image/jpeg', 1);
    // Dynamically import jsPDF only when needed
    import('jspdf').then(({ jsPDF }) => {
      // Create an image to get actual dimensions
      const image = new Image();
      image.src = img;
      
      image.onload = () => {
        const imgWidth = image.width;
        const imgHeight = image.height;
        const aspectRatio = imgWidth / imgHeight;
        
        // PDF page dimensions (A4: 210mm x 297mm)
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 10;
        const maxWidth = pdfWidth - (margin * 2);
        const maxHeight = pdfHeight - (margin * 2);
        
        // Calculate dimensions maintaining aspect ratio
        let finalWidth = maxWidth;
        let finalHeight = finalWidth / aspectRatio;
        
        // If height exceeds max, scale based on height instead
        if (finalHeight > maxHeight) {
          finalHeight = maxHeight;
          finalWidth = finalHeight * aspectRatio;
        }
        
        // Center the image on the page
        const xOffset = (pdfWidth - finalWidth) / 2;
        const yOffset = (pdfHeight - finalHeight) / 2;
        
        const pdf = new jsPDF();
        pdf.addImage(img, 'PNG', xOffset, 20, finalWidth, finalHeight);
        pdf.save(fileName + '.pdf');
      };
    });
  }

  getChartLegendPosition(configPosition?: string): any {
    let position: any = {};
    switch (configPosition) {
      case 'top':
        position = { top: '20', orient: 'horizontal' };
        break;
      case 'bottom':
        position = { bottom: 'bottom', orient: 'horizontal' };
        break;
      case 'left':
        position = { left: 'left', top: 'center', orient: 'vertical' };
        break;
      case 'right':
        position = { right: 'right', top: 'center', orient: 'vertical' };
        break;
      default:
        position = { top: '20', orient: 'horizontal' };
        break;
    }

    return position;
  }

}